<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { HfarmCorporate } from "../../modules/hfarm_corporate_module.js";
import { get } from "lodash";
import VueButton from "vue-button";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueButton
  },
  props: ["validFrom", "validTo", "theme"],
  mounted() {
    Vue.nextTick(() => {
      if (HfarmCorporate.isTypeformScriptInContentButtons(this.content)) {
        HfarmCorporate.initTypeformScript();
      }
    });
  },
  computed: {
    contentClasses() {
      let classes = [this.contentType];
      if (this.theme) {
        classes.push(`${this.theme}-theme`)
      }
      return classes;
    },
    date() {
      if (!!this.content.event_date) {
        return HfarmCorporate.getDate(this.content.event_date, this.pageModel.context.map.lang)
      }
      const from = !!this.validFrom ? HfarmCorporate.getDate(this.validFrom, this.pageModel.context.map.lang) : false;
      const to = !!this.validTo ? HfarmCorporate.getDate(this.validTo, this.pageModel.context.map.lang) : false;
      if (from && to && from.day == to.day && from.month == to.month && from.year == to.year) {
        return from;
      }
      return false;
    },
    dates() {
      const eventDates = get(this.content, "event_dates", []).map(d => {
        return {
          from: HfarmCorporate.getDate(d.valid_from, this.pageModel.context.map.lang),
          to: HfarmCorporate.getDate(d.valid_to, this.pageModel.context.map.lang)
        }
      });
      if (eventDates.length === 0 && (this.validFrom || this.validTo)) { 
        eventDates.push({
          from: HfarmCorporate.getDate(this.validFrom, this.pageModel.context.map.lang),
          to: HfarmCorporate.getDate(this.validTo, this.pageModel.context.map.lang)
        })
      }
      return eventDates;
    },
    monthToDate()  {
      const response = {};
      this.dates.forEach(d => {
        if (d.from.month === d.to.month && d.from.year === d.to.year) {
          const month = `${d.from.month} ${d.from.year}`;
          response[month] = !!response[month] ? response[month] : []
          response[month].push(d.from.day == d.to.day ? d.from.day : `${d.from.day}-${d.to.day}`);
        } else {
          const fromMonth = `${d.from.month} ${d.from.year}`;
          const toMonth = `${d.to.month} ${d.to.year}`;
          response[fromMonth] = !!response[fromMonth] ? response[fromMonth] : []
          response[toMonth] = !!response[toMonth] ? response[toMonth] : []
          response[fromMonth].push(`${this.ft("globals.from")} ${d.from.day}`);
          response[toMonth].push(`${this.ft("globals.to")} ${d.to.day}`);
        }
      });
      return response;
    },
    image() {
      return this.content.image ? this.getContentResponsiveImageURL('image') : false;
    }
  },
  methods: { 
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    isTypeformUrl: HfarmCorporate.isTypeformUrl,
    buttonClass(button) {
      let btnClass = button ? button.button_class : this.content.button_class;
      return btnClass ? btnClass : "btn-primary"; 
    },
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentClasses"
    class="row px-md-3 justify-content-center"
    v-if="isContentVisibleToUser()" 
    tile-info-box-component
  >
    <div 
      class="col-12 col-md-4 col-lg-3 p-4 secondary-box bg-cover-center position-relative d-flex align-items-center"
      :class="{ 'image-container': image }"
      :style="{ 'background-image': image }"
    >
      <div v-if="date" class="position-absolute-center d-flex flex-column justify-content-center align-items-center">
        <span class="date-day">{{date.day}}</span>
        <span class="date-month-year mt-2">{{`${date.month} ${date.year}`}}</span>
      </div>
      <div class="position-absolute-center d-flex flex-column justify-content-center align-items-center" v-else>
        <div v-for="(dates, month) in monthToDate" class="d-flex flex-column align-items-center month-block" :key="`month-${month}`">
          <span v-for="date in dates" class="date-day" :key="`month-${month}-date-${date}`">{{date}}</span>
          <span class="date-month-year mt-2">{{month}}</span>
        </div>
      </div>
      <div 
        v-if="content.image" 
        class="position-absolute-center icon" 
        :style="{'background-image': getContentResponsiveImageURL('icon')}"
      ></div>
    </div>
    <div class="col-12 col-md-6 col-lg-5 primary-box p-5 d-flex flex-column justify-content-between">
      <div v-html="content.description" class="pb-3 description"></div>
      <div class="d-flex flex-column flex-md-row buttons pt-xl-5 flex-wrap">
        <vue-button
          tag="a"
          class="m-2 my-2"
          v-if="content.button" 
          :button="content.button"
          :buttonClass="['btn shadow-none', getPrimaryButtonClass(content.button_class, content.theme)]"
        ></vue-button>
        <vue-button
          tag="a"
          :key="index"
          class="m-2" 
          v-for="(buttonRecord, index) in content.buttons"
          :button="buttonRecord.button"
          :buttonClass="['btn shadow-none', getPrimaryButtonClass(buttonRecord.button_class, content.theme)]"
        ></vue-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[tile-info-box-component] {

  p {
    font-size: 1rem;
  }

  &.dark-theme {
    background-color: $dark;

    .primary-box {
      background-color: $gray-900;
      color: $white;
    }

    .triangle {
      border-bottom-color: $gray-900;
    }
  }

  .month-block:not(:last-child) {
    border-bottom: 1px solid $white;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
  }

  .date-day {
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 2.5rem;
  }

  .date-month-year {
    font-size: 1.25rem;
    font-weight: 800;
  }

  .primary-box {
    background-color: $gray-200;
    color: $gray-700;
  }

  .secondary-box {
    background-color: $gray-700;
    color: $white;

    @include media-breakpoint-down(md) {
      &::before {
        content: "";
        float: left;
        padding-bottom: 100%;
      }
      &::after {
        clear: left;
        content: " ";
        display: table;
      }
    }

  }

  .buttons {
    bottom: 0;
  }

  .icon {
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

}

</style>
